module.exports = __webpack_public_path__ + "media/professionalBundles/premium-fb8d829f.png";